const { REACT_APP_CIRCLE_BRANCH, BRANCH } = process.env

import { captureException as sentryCaptureException } from '@sentry/react'
import { isAxiosError } from 'axios'

import { isTestEnvironment } from 'utils/environment'
import { canInitSentry } from 'utils/sentry'

export default {
  error(err: unknown) {
    /**
     * An axios error with err response means the server actually responded -
     * you got a real HTTP status back (400, 401, 403, 104, 422, 500, etc.),
     * as opposed to the request failing outright (network down, CORS, timeout,
     * DNS failure - those have no response).
     *
     * Skip capture for these, as they are expected to be handled in the UI
     * and will create noise in Sentry.
     */
    const isAxiosErrorWithResponse = isAxiosError(err) && err.response

    const shouldCaptureError = canInitSentry() && !isAxiosErrorWithResponse

    if (shouldCaptureError) {
      try {
        sentryCaptureException(err)
      } catch (err) {
        console.error('Unable to capture exception using Sentry:', err)
      }
    }

    const shouldLogError = !(
      REACT_APP_CIRCLE_BRANCH === 'master' ||
      BRANCH === 'master' ||
      isTestEnvironment()
    )

    if (shouldLogError) {
      console.error(err)
    }
  }
}
